
class FormOfferResponse extends require('common/helpers/validate') {
   // Validation schema
   get schema() {
      return {
         offerid: {
            required: true,
            type: 'string'
         },
         offeraction: {
            required: true,
            type: 'string'
         },
         deferperiod: {
            required_when: ['offeraction','defer']
         },
         type: {
            type: 'string'
         }
      }
   }
}

module.exports = FormOfferResponse
